import React from 'react';

import moment from 'moment';

import FlightSector from 'components/FlightSector';
import SimpleAlert from 'components/SimpleAlert';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { Sector } from 'models/sector';

import { Container, Header, SectorContainer, SectorDivider } from './styles';

interface Props {
  sectors: Sector[];
  breakRulesMessage?: string[];
}

const FlightsDetails = ({ sectors, breakRulesMessage = [] }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Container>
      {breakRulesMessage.length > 0 && (
        <SimpleAlert
          title={t('flightDetails.outOfPolicies')}
          content={
            <ul>
              {breakRulesMessage.map((msg) => (
                <li key={msg}>&bull; {msg}</li>
              ))}
            </ul>
          }
        />
      )}
      {sectors.map((sector: Sector, index: number) => (
        <React.Fragment key={sector.sectorNumber}>
          {index === 1 && <SectorDivider />}
          <SectorContainer>
            <Header>
              <Header.Type>
                {sectors.length > 2
                  ? t('flightsDetails.multiDestination')
                  : t(index === 0 ? 'flightsDetails.departure' : 'flightsDetails.return')}
              </Header.Type>
              <Header.Date>
                {moment(sector.flights.first().departureDate).utc().format('ddd[,] D MMM YYYY')}
              </Header.Date>
              <Header.Destiny>
                {`${sector.flights.first().departureAirport} - ${sector.flights.last().arrivalAirport}`}
              </Header.Destiny>
            </Header>
            <FlightSector sector={sector} />
          </SectorContainer>
        </React.Fragment>
      ))}
    </Container>
  );
};

export default FlightsDetails;
